exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreement-iframe[data-v-0232461a] {\n  height: 100vh;\n  width: 100%;\n}\n", ""]);

// exports
